var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "new-allocation-panel"
    }
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "z-index": "9"
    }
  }, [_c('legend', [_vm._v("Print Request")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "tabs-active",
    staticStyle: {
      "box-shadow": "1px solid #494949"
    }
  }, [_c('b-tabs', {
    staticClass: "NewAllocationtab",
    attrs: {
      "content-class": "mt-3"
    },
    model: {
      value: (_vm.ActiveTabIndex),
      callback: function($$v) {
        _vm.ActiveTabIndex = $$v
      },
      expression: "ActiveTabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": _vm.tabTitle('Print', _vm.totalPrintPendingShipment),
      "active": _vm.ActiveTabIndex === 0
    },
    on: {
      "click": function($event) {
        return _vm.SwitchTabs('print')
      }
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": _vm.tabTitle('Reprint', _vm.totalRePrintPendingShipment),
      "active": _vm.ActiveTabIndex === 1
    },
    on: {
      "click": function($event) {
        return _vm.SwitchTabs('reprint')
      }
    }
  })], 1), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "b-table table table-bordered"
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', [_vm._v("Shipping Id")]), _vm._v(" "), _c('th', [_vm._v("UserName")]), _vm._v(" "), _c('th', [_vm._v("Center")]), _vm._v(" "), _c('th', [_vm._v("Overall Print")]), _vm._v(" "), _c('th', [_vm._v("Comment")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', [(_vm.pendingrequestlist.length > 0) ? _vm._l((_vm.pendingrequestlist), function(row) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(row.shippingid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.username))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.centertype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.printcount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.comment))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-sm btn-success",
      on: {
        "click": function($event) {
          return _vm.approveShipment(row.shippingid, row.requestsource)
        }
      }
    }, [_vm._v("Approve")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-danger",
      on: {
        "click": function($event) {
          return _vm.rejectedShipment(row)
        }
      }
    }, [_vm._v("Reject")])])])
  }) : [_c('tr', [_c('td', {
    attrs: {
      "colspan": "12",
      "align": "center"
    }
  }, [_vm._v("No record found")])])]], 2)]), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalPendingShipment > 1),
      expression: "totalPendingShipment>1"
    }],
    ref: "paginate",
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)], 1)])], 1)]), _vm._v(" "), (_vm.restrictTLQCModal == true) ? _c('b-modal', {
    attrs: {
      "size": "vlg",
      "id": "restrictTLQCModal",
      "title": "Process QC Check",
      "z-index": "9999999999"
    },
    model: {
      value: (_vm.restrictTLQCModal),
      callback: function($$v) {
        _vm.restrictTLQCModal = $$v
      },
      expression: "restrictTLQCModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("TLQC Restrict")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModelRestrict
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "col-md-12 card qcCheckPanel"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_vm._v("\n                                        " + _vm._s(_vm.restrictTLQCError))])]), _c('br')])])])])])])]) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53529080","hasScoped":true}!./src/views/components/RVPPrintLabelRequest/RVPPrintLabelRequest.component.html
// module id = 1588
// module chunks = 1